export default __webpack_public_path__ + "static/media/5.1da92302.webp";